const isTestEnv = process.env.NODE_ENV === 'test';

export function requireImage(path, format) {
  const isFormatWebp = format === 'webp';
  if (isFormatWebp) {
    return isTestEnv ? `public/images/${path}.webp` : require(`public/images/${path}?webp`);
  }

  return isTestEnv ? `public/images/${path}` : require(`public/images/${path}`);
}
